import styled from "styled-components";

export const TextButton = styled.div`
    text-align: center;
    vertical-align: middle;
    color: #417F90;
    white-space: nowrap;
    font-size: 14px;
    line-height: 1.428571429;
    user-select: none;
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 0px;
    padding-bottom: 0px;
    cursor: pointer;
    &:hover {
        transform: translateY(-1px);
    }
`

const Button = styled.button`
    min-width: 65px;
    color:${p => p.disabled ? "#545F66" : "white"};
    background-image: none;
    height: ${p => p.slim ? "22" : "30"}px;
    border-radius: 3px;
    box-shadow: ${p => p.disabled ? "0 0 0 0" : "0px 1px 3px 0px rgba(51, 51, 51, 0.5)"};
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 0px;
    padding-bottom: 0px;
    display: inline-block;
    margin-bottom: 0;
    text-align: center;
    vertical-align: middle;
    cursor: pointer;
    border:  ${p => p.disabled ? "dotted 1px #545F66" : "1px solid transparent"};
    white-space: nowrap;
    font-size: 14px;
    line-height: 1.428571429;
    user-select: none;
    background: ${p => {
        let color = 'inhert';
        color = p.standard ? p.theme.colors.standard : color;
        color = p.uncommon ? p.theme.colors.uncommon : color;
        color = p.subtle ? p.theme.colors.subtle : color;
        color = p.disabled ? "#FFF" : color;
        return color;
    }};
    outline: none;
    &:active {
        background: ${p => {
        if (p.standard) {
            return p.theme.colors.standardDark;
        }
        else if (p.uncommon) {
            return p.theme.colors.uncommonDark;
        } else if (p.subtle) {
            return p.theme.colors.subtleDark;
        }
        return 'inhert';
    }};
        box-shadow: 0 0 0 0;
    }
    &:hover {
        color: white;
        transform: ${p => {
        if (p.disabled) {
            return "translateY(0px)";
        }
        else {
            return "translateY(-1px)";
        }
    }};
        background: ${p => {
        if (p.standard) {
            return p.theme.colors.standardLight;
        }
        else if (p.uncommon) {
            return p.theme.colors.uncommonLight;
        } else if (p.subtle) {
            return p.theme.colors.subtleLight;
        }
        return 'inhert';
    }};
    }
    &:disabled {
        border: dotted 1px #545F66;
        color: #545F66;
        background-color: #FFF ;
        opacity: 1 ;
        box-shadow: 0 0 0 0 ;
        cursor: not-allowed;
    }
`;


export default Button